<script setup lang="ts">
import InfoIcon from '@/components/icons/InfoIcon.vue'

interface Props {
  content: string
  color?: string
}

defineProps<Props>()
</script>

<template>
  <div class="tooltip">
    <v-menu open-on-hover open-on-click location="top" offset="5" content-class="elevation-1">
      <template v-slot:activator="{ props }">
        <InfoIcon v-bind="props" class="tooltip-icon" :style="{ fill: color }" />
      </template>
      <div class="tooltip-content">
        <div v-html="content" class="tooltip-text"></div>
      </div>
    </v-menu>
  </div>
</template>

<style lang="scss" scoped>
.tooltip {
  line-height: 0;
  cursor: pointer;
}

.tooltip-icon {
  fill: var(--ui-black);

  &:focus {
    outline: none;
  }
}

.tooltip-content {
  width: 200px;
  min-height: 100px;
  background: var(--ui-white);
  text-align: left;
  padding: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.tooltip-text {
  padding-bottom: 5px;
  color: var(--ui-black);
  font-size: 14px;
  line-height: 20px;
}
</style>
